"use client";

import { Link, getPathname } from "@/i18n/navigation";
import { clsx } from "clsx";
import { useLocale } from "next-intl";

export default function SectionHeader({
  title,
  description,
  linkText,
  href,
  preserveTrailingSlash = false,
  align = "left",
  className = "",
  titleAs = "h2",
}) {
  const isCentered = align === "center";
  const TitleTag = titleAs;
  const locale = useLocale();
  const shouldPreserveSlash =
    preserveTrailingSlash && typeof href === "string" && href.endsWith("/");
  const linkHref = shouldPreserveSlash
    ? `${getPathname({ href: href.slice(0, -1) || "/", locale })}/`
    : href;

  return (
    <div
      className={clsx(
        "flex w-full flex-col justify-center space-y-1",
        isCentered ? "items-center text-center" : "items-start text-left",
        className,
      )}
    >
      <div
        className={clsx(
          "flex w-full flex-row items-center justify-between",
          isCentered && "justify-center",
        )}
      >
        <TitleTag className="color-foreground text-sm-line md:text-xl-custom m-0 leading-6 font-semibold lg:text-[29px] lg:leading-8">
          {title}
        </TitleTag>

        {href && linkText && !isCentered &&
          (shouldPreserveSlash ? (
            <a
              href={linkHref}
              title={linkText}
              className="text-primary shrink-0 cursor-pointer text-base leading-21 font-medium md:text-base"
            >
              {linkText}
            </a>
          ) : (
            <Link
              href={href}
              title={linkText}
              className="text-primary shrink-0 cursor-pointer text-base leading-21 font-medium md:text-base"
            >
              {linkText}
            </Link>
          ))}
      </div>

      {description && (
        <p className="text-primary-muted-subtext text-sm">{description}</p>
      )}
    </div>
  );
}
